
import { currentUser, getUserFolders, refreshUserFolders } from ".";
import { FolderCreateEvent, FolderDeleteEvent } from "@/utils/events/folder";

export const isEditor = currentUser?.editor;

export function getEditorFolders(userId) {
  return getUserFolders().then((data) => {
    return data;
  });
}

export const IS_EDITOR_WITHOUT_FOLDERS = ko.observable(false);
export const CHECKING_EDITOR_FOLDERS = ko.observable(isEditor)

// Каждая webpack-точка входа собирает собственную копию этого модуля (и этой observable),
// поэтому папка, созданная на одной странице (например, списке опросов), не обновляет
// по ссылке копию из другого бандла (например, сайдбара). FolderCreateEvent идёт через
// window.FoquzEvent, который общий для всех бандлов, чтобы держать все копии в синхронизации.
// В расширенном режиме папок (задача #6536) у редактора могут быть только папки
// с гостевым доступом (расшаренные ему) и ни одной с полным доступом. У него всё
// равно есть папки для работы, поэтому он не считается "без папок".
function applyEditorFoldersState(list) {
  const hasGuestFolders =
    Array.isArray(window.GUEST_FOLDERS) && window.GUEST_FOLDERS.length > 0;
  IS_EDITOR_WITHOUT_FOLDERS(
    (!Array.isArray(list) || !list.length) && !hasGuestFolders
  );
  CHECKING_EDITOR_FOLDERS(false);
}

FolderCreateEvent.on(() => IS_EDITOR_WITHOUT_FOLDERS(false));
if (isEditor) {
  getEditorFolders().then(applyEditorFoldersState);
  // Удаление последней папки должно сразу блокировать "Создать опрос" (#6537, п.3).
  FolderDeleteEvent.on(() => {
    refreshUserFolders().then(applyEditorFoldersState);
  });
}
